import { useEffect, useState } from 'react';

// Immersive (fullscreen, phone) video: the header and control bar float over
// the picture and fade out after a few seconds of playback with no touch -
// a tap on the video brings them back (or hides them right away). While
// not `enabled` (windowed, desktop) they're simply always shown.
const HIDE_AFTER_MS = 3000;

export function useAutoHideChrome(enabled, playing) {
  const [hidden, setHidden] = useState(false);
  // Bumped by every interaction, so the hide timer restarts from it.
  const [lastPoke, setLastPoke] = useState(0);

  useEffect(() => {
    if (!enabled) setHidden(false);
  }, [enabled]);

  useEffect(() => {
    if (!enabled || !playing || hidden) return undefined;
    const timer = setTimeout(() => setHidden(true), HIDE_AFTER_MS);
    return () => clearTimeout(timer);
  }, [enabled, playing, hidden, lastPoke]);

  const poke = () => {
    setHidden(false);
    setLastPoke(Date.now());
  };
  const toggle = () => {
    if (hidden) poke();
    else setHidden(true);
  };

  return { chromeHidden: enabled && hidden, poke, toggle };
}
